module.exports = __webpack_public_path__ + "img/11_sustainableCitiesAndCommunities.00060950.png";